import { Component } from '@angular/core';
import { EmployeeInformationAndDriverLicense } from 'src/app/components/employee-information-and-driver-license/employee-information-and-driver-license';

@Component({
  selector: 'app-employee-information-and-driver-license-page',
  imports: [EmployeeInformationAndDriverLicense],
  templateUrl: './employee-information-and-driver-license-page.html',
  styleUrl: './employee-information-and-driver-license-page.scss',
})
export class EmployeeInformationAndDriverLicensePage {}
